import {
    LOADER_OFF,
    LOADER_ON,
} from 'store/actions/types';

export default function loadingReducer(state = 0, action) {
    switch (action.type) {
        case LOADER_ON:
            return state + 1;
        case LOADER_OFF:
            if (state > 0) {
                return state - 1;
            }

            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/loaderReducer.js